<template>
  <div
    class="alertMask"
    v-show="visiable"
    @click.self="maskClose && closeClick()"
    @touchmove.self="e => e.preventDefault()"
  >
    <div class="alertContainer" :class="{ showing }">
      <div class="closeIcon" v-show="!noClose" @click="closeClick"></div>
      <div class="alertContent">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 悬浮弹窗组件
 * @prop {Boolean} show | false 是否显示弹窗
 * @prop {Boolean} noClose | false 是否隐藏关闭按钮
 * @prop {Boolean} maskClose | false 是否开启遮罩层关闭功能
 *
 * @method close 弹窗触发关闭事件时会触发,一般在父组件中写关闭逻辑
 */
export default {
  props: ['show', 'noClose', 'maskClose'],
  data() {
    return {
      visiable: false,
      showing: false
    };
  },
  created() {
    this.visiable = this.show;
    this.showing = this.show;
  },
  watch: {
    show(v) {
      if (v) {
        this.visiable = true;
        document.documentElement.style.overflow = 'hidden';
        setTimeout(() => (this.showing = true), 0);
      } else {
        this.showing = false;
        document.documentElement.style.overflow = 'inherit';
        setTimeout(() => (this.visiable = false), 500);
      }
    },
    $route() {
      document.documentElement.style.overflow = 'inherit';
    }
  },
  methods: {
    closeClick() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="less" scoped>
.alertMask {
  .fc;
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);

  .alertContainer {
    position: relative;
    transform: translateY(200%);
    box-sizing: border-box;
    width: 582px;
    min-height: 431px;
    max-height: 678px;
    border-radius: 20px;
    background-color: #ffffff;
    transition: all 0.5s;

    &.showing {
      transform: translateY(0%);
    }

    .closeIcon {
      position: absolute;
      transform: translate(-50%, -50%);
      left: 100%;
      top: 0;
      width: 52px;
      height: 52px;
      border-radius: 50%;
      background-image: url(../assets/UI/close_icon.png);
      .bf;
    }

    .alertContent {
      .fcc;
    }
  }
}
</style>
